import { stripSpaces } from "../../../../../utils";
import FileSimilarityFilter from "./FileSimilarityFilter";

type Props = {
  label: string;
  fileSize?: number;
  fileType: string;
  threatName?: string;
  sha1?: string;
  hasRha?: boolean;
  hasTlsh?: boolean;
  hasSsdeep?: boolean;
};

const FileSimilarity = ({
  label,
  fileSize,
  fileType,
  sha1,
  threatName,
  hasRha,
  hasTlsh,
  hasSsdeep
}: Props) => {
  const minSize = fileSize ? Math.ceil(fileSize - fileSize * 0.1) : 0; // -10%
  const maxSize = fileSize ? Math.ceil(fileSize + fileSize * 0.1) : 0; // +10%
  const baseQuery = `similar-to:${sha1}`;
  const menuItems = [
    {
      id: "similar_by_file_type",
      label: "Similar by File Type",
      query: `${baseQuery} filetype:${stripSpaces(fileType)}`
    }
  ];
  if (threatName) {
    menuItems.push({
      id: "similar_by_threat_name",
      label: "Similar by Threat Name",
      query: `${baseQuery} threatname:${threatName}`
    });
  }
  menuItems.push({
    id: "similar_by_file_size",
    label: "Similar by File Size",
    query: `${baseQuery} size:[${minSize} TO ${maxSize}]`
  });

  if (hasRha) {
    menuItems.splice(0, 0, {
      id: "similar_by_rha_hash_first_seen",
      label: "Similar by RHA Hash (by first seen)",
      query: baseQuery
    });
  }

  return (
    <FileSimilarityFilter
      hasRha={hasRha}
      hasTlsh={hasTlsh}
      hasSsdeep={hasSsdeep}
      label={label}
      items={menuItems}
    />
  );
};

export default FileSimilarity;
